import { render, staticRenderFns } from "./AssignmentsList.vue?vue&type=template&id=dd150216&"
import script from "./AssignmentsList.vue?vue&type=script&lang=js&"
export * from "./AssignmentsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/sapphire/K12Live16/build/CommunityWebPortal/_app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dd150216')) {
      api.createRecord('dd150216', component.options)
    } else {
      api.reload('dd150216', component.options)
    }
    module.hot.accept("./AssignmentsList.vue?vue&type=template&id=dd150216&", function () {
      api.rerender('dd150216', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/classPage/AssignmentsList.vue"
export default component.exports